// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_u5-0";